import PageCard from '../components/UI/PageCard';
import StatsCard from '../components/homebody/StatsCard';

const Fixtures = () => {
  return (
    <PageCard>
      <StatsCard />
    </PageCard>
  );
};

export default Fixtures;
